<template>
<section class="subhero section" aria-labelledby="global-direct-subhero">

        <div class="container pt-5">
        <div class="text-center header" data-aos="fade" data-aos-duration="1000" data-aos-once="true" data-aos-delay="400">
        <!-- <h2 id="global-direct-features">Register Now: Classes Start Monthly</h2> -->
        </div>
    <div class="row g-4 py-5 row-cols-1 row-cols-lg-4 text-center">
        
        <div class="col" data-aos="fade" data-aos-delay="500" data-aos-duration="1000" data-aos-once="true" data-aos-anchor=".header">
            <img src="https://images.prismic.io/csug/2626203d-8921-4442-9505-30098fbd4969_icon_100_online.png" />
            <p>ACCREDITED ONLINE PREREQUISITE COURSES</p>
        </div><!--end col-->

        <div class="col" data-aos="fade" data-aos-delay="600" data-aos-duration="1000" data-aos-once="true" data-aos-anchor=".header">
            <img src="https://images.prismic.io/csug/d7364a0d-f0b5-4697-9058-25cdd23fbeb5_icon_no_set_times.png" />
            <p>NO SET TIMES OR LOCATIONS</p>
        </div><!--end col-->

        <div class="col" data-aos="fade" data-aos-delay="700" data-aos-duration="1000" data-aos-once="true" data-aos-anchor=".header">
            <img src="https://images.prismic.io/csug/ea1b65b1-1dea-4515-a4b6-fc364bd0b700_icon_monthly_start.png" />
            <p>MONTHLY CLASS STARTS</p>
        </div><!--end col-->

        <div class="col" data-aos="fade" data-aos-delay="800" data-aos-duration="1000" data-aos-once="true" data-aos-anchor=".header">
            <img src="https://images.prismic.io/csug/a228f570-c4ce-4cba-aa61-c176690f9095_icon_assess_financial.png?auto=compress,format" />
            <p>NO APPLICATION FEES OR ADMISSIONS REQUIREMENTS</p>
        </div><!--end col-->

       



    </div><!--end row-->
    </div><!--end contain-->
</section>
</template>

<script>
export default {
    name: 'SubHero',
    props: {

    },

}
</script>

<style scoped lang="scss">
img {
    margin-bottom:1rem;
}

</style>
